import moment from 'moment';
import 'moment-timezone';

export class DateUtil {


    public static readonly FRONTEND_DATE = 'DD.MM.YYYY';
    public static readonly FRONTEND_DATE_TIME = 'DD.MM.YYYY hh:mm';
    public static readonly FRONTEND_TIME = 'HH:mm';
    public static readonly BACKEND_DATE = 'YYYY-MM-DD';
    public static readonly BACKEND_DATE_TIME = 'YYYY-MM-DD hh:mm';

    public static formatTimestampToDate(timestamp: any): string {
        return moment(timestamp).isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').tz('Europe/Berlin').format(this.FRONTEND_DATE)
            : '';
    }

    public static formatTimestampToTime(timestamp: any): string {
        return moment(timestamp).isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').tz('Europe/Berlin').format(this.FRONTEND_TIME)
            : '';
    }

    public static isTodayInPeriod(start: string, end: string): boolean {
        return DateUtil.formatStringToDate(start) >= new Date() && DateUtil.formatStringToDate(end) <= new Date();
    }

    public static formatStringToDate(timestamp: string): Date {
        return moment(timestamp, this.FRONTEND_DATE).isValid()
            ? moment.tz(timestamp, this.FRONTEND_DATE, 'Europe/Berlin').tz('Europe/Berlin').toDate()
            : null;
    }

    public static formatBackendDateStringToDateString(dateString: string): string {
        return moment(dateString, this.BACKEND_DATE).isValid()
          ? moment(dateString).format(this.FRONTEND_DATE) : '';
    }

    public static formatBackendDateTimeStringToDateString(dateTimeString: string): string {
        return moment(dateTimeString, this.BACKEND_DATE_TIME).isValid()
          ? moment(dateTimeString).format(this.FRONTEND_DATE) : '';
      }

    public static formatTimestampToDateTimeMinusDays(timestamp: any, days: number): string {
        return moment(timestamp).subtract(days, 'days').isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').subtract(days, 'days').tz('Europe/Berlin').format(this.FRONTEND_DATE_TIME)
            : '';
    }

    public static formatTimestampToDateMinusDays(timestamp: any, days: number): string {
        return moment(timestamp).subtract(days, 'days').isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').subtract(days, 'days').tz('Europe/Berlin').format(this.FRONTEND_DATE)
            : '';
    }

    public static formatTimestampToTimeMinusDays(timestamp: any, days: number): string {
        return moment(timestamp).subtract(days, 'days').isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').subtract(days, 'days').tz('Europe/Berlin').format(this.FRONTEND_TIME)
            : '';
    }

    public static formatTimestampToDatePlusDays(timestamp: any, days: number): string {
        return moment(timestamp, this.BACKEND_DATE_TIME).add(days, 'days').tz('Europe/Berlin').isValid()
            ? moment.tz(timestamp, this.BACKEND_DATE_TIME, 'Europe/Berlin').add(days, 'days').tz('Europe/Berlin').format(this.FRONTEND_DATE)
            : '';
    }

    public static formatTimestampToDateTime(timestamp: any): string {
        return moment(timestamp).isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').tz('Europe/Berlin').format(this.FRONTEND_DATE_TIME)
            : '';
    }

    public static formatTimestampToYear(timestamp: any): string {
        return moment(timestamp).isValid()
            ? moment.tz(timestamp, 'Europe/Berlin').tz('Europe/Berlin').format('YYYY')
            : '';
    }

    public static formatTimestampToMonth(timestamp: any): number {
        return +moment.tz(timestamp, 'Europe/Berlin').tz('Europe/Berlin').format('M');
    }

    public static formatBackendDateToDate(date: string): Date {
        return moment(date, this.BACKEND_DATE).isValid()
            ? moment.tz(date, this.BACKEND_DATE, 'Europe/Berlin').tz('Europe/Berlin').toDate()
            : null;
    }

    public static formatFrontendDateToDate(date: string): Date {
        return moment(date, this.FRONTEND_DATE).isValid()
            ? moment.tz(date, this.FRONTEND_DATE, 'Europe/Berlin').tz('Europe/Berlin').toDate()
            : null;
    }

    public static formatStringToTime(dateString: string): string {
        return moment(dateString, this.FRONTEND_TIME).isValid()
          ? moment(dateString).format(this.FRONTEND_TIME) : '';
      }
}
